var render = function render(_c,_vm){return _c('span',[_c('span',{class:{'invisible': _vm.props.busy}},[_vm._t("default")],2),(_vm.props.busy)?_c('div',{staticClass:"centered"},[_c('b-spinner',{staticClass:"align-middle",attrs:{"small":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }